import { BaseModel } from "@/models/base.model.ts"
import type { IIncomingInvoicePurchase } from "@/interfaces/api/incoming-invoice-purchase.interface.ts"

export class IncomingInvoicePurchase extends BaseModel implements IIncomingInvoicePurchase {
  public static className = "IncomingInvoicePurchase"
  public static verboseName = "Inkoopfactuur-inkoop"

  incomingInvoiceReference: string

  incomingInvoice: string
  purchase: string
  quantity: string

  constructor(incomingInvoicePurchase: IIncomingInvoicePurchase) {
    super(incomingInvoicePurchase)

    this.incomingInvoiceReference = incomingInvoicePurchase.incomingInvoiceReference

    this.incomingInvoice = incomingInvoicePurchase.incomingInvoice
    this.purchase = incomingInvoicePurchase.purchase
    this.quantity = incomingInvoicePurchase.quantity
  }
}
